<section class=" px-0 sm:px-[9.3%] py-8 lg:py-12 3xl:py-16">
  <div class="relative">
    <video  class="absolute inset-0 w-full h-full object-cover z-0 sm:rounded-md 3xl:rounded-lg" loop muted autoplay
      oncanplay="this.play()" onloadedmetadata="this.muted = true">
      <source src="assets/hero/waves2.mp4" type="video/mp4">
    </video>
    <div class="absolute inset-0 bg-video-overlay opacity-80 z-10 sm:rounded-md 3xl:rounded-lg"></div>
    <div
      class="relative z-20 flex flex-col lg:flex-row justify-between items-end gap-8 lg:gap-4 3xl:gap-6 sm:rounded-md 3xl:rounded-lg p-8 lg:p-12 3xl:p-16 text-white">
      <div class="w-full lg:w-3/5">
        <h2
          class="text-3xl sm:text-4xl xl:text-5xl 2xl:text-[52px] 3xl:text-[64px] xl:leading-[54px] 2xl:leading-[64px] 3xl:leading-[76.8px] font-semibold 3x:font-bold mb-6 3xl:mb-8 w-full sm:w-4/5 lg:w-full">
          Transforming Ideas into <br class="hidden lg:inline"> Market-Ready Products</h2>
        <a href="https://webforms.pipedrive.com/f/6iCHNNECUuqORf9rWJgygfwg3GR0OuWejL9ZkdXTDfW1Z5Gu2Kc2odVMCTOHP8Ub4L"
          target="_blank"><app-button class=" inline-block" size="large" heading="Get in touch"
            icon="assets/shared/webform.svg"></app-button></a>
        <img height="675" width="127" loading="lazy" class="w-full h-auto py-8 lg:py-12 3xl:py-16" src="assets/home/ideas/line.png" alt="line-img">
        <div class="flex gap-6 lg:gap-12 3xl:gap-16">
          <div *ngFor="let achievmnent of achievemnets" class="flex flex-col">
            <h3
              class="text-3xl sm:text-4xl 3xl:text-5xl lg-leading-[40px] 3xl:leading-[57.6px] font-semibold 3xl:font-bold mb-1 3xl:mb-2">
              {{achievmnent.quantity}}<span
                class="text-xl sm:text-2xl 3xl:text-3xl font-semibold 3xl:font-bold">+</span></h3>
            <p class="text-base 3xl:text-xl leading-[24px] 3xl:leading-[28px] font-light 3xl:font-normal">
              {{achievmnent.desc}}</p>
          </div>
        </div>
      </div>
      <div class="w-full lg:w-2/5">
        <h3
          class="text-center sm:text-left text-base 3xl:text-xl leading-[24px] 3xl:leading-[28px] font-medium 3xl:font-bold mb-6 3xl:mb-8">
          Certifications</h3>
        <div class="flex justify-center sm:justify-start items-center flex-wrap gap-6 3xl:gap-8">
          <div *ngFor="let certificate of certifications">
            <img height="76" width="76" loading="lazy" [src]='certificate' alt="img" class="w-14 h-auto xl:w-12 2xl:w-14 3xl:w-[70px]">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>